import {BaseStore, globalStore} from "../../stem-core/state/Store";
import {apiClient} from "../connection/BlinkApiClient";
import {field} from "../../stem-core/state/StoreField";
import {CycleUnit} from "./RecurringPaymentStoreObject";
import {Merchant} from "./MerchantStore";
import {Currency} from "../../stem-core/localization/CurrencyStore";


export function getFeeRawPercentage(merchantId: number): number {
    // TODO Fucking Denis and Jean, thanks guys
    return 0.079;
}

@globalStore
export class DonationOffer extends BaseStore("donationOffer") {
    declare merchanId: number;
    @field("Merchant") merchant: Merchant;
    @field("Currency") currency: Currency;
    @field(Number) maxPaymentAttemptsCount: number;
    @field(Number) paymentAttemptDelayHours: number;
    @field(Number) attemptsBeforeNextCycle: number;
    @field(Number) useCalendarPeriod: number;
    @field(Array) frequencyOptions: string[];
    @field(CycleUnit) defaultFrequency: CycleUnit;
    //@field(Array) predefinedAmounts; // TODO @Mihai fix when that proxy obj works
    @field(Number) defaultPredefinedAmountIndex: number;
    @field(Number) maxPredefinedAmountsSize: number;
    @field(Boolean) allowCustomAmount: boolean;
    @field(Boolean) collectAddress: boolean;

    shouldCollectAddress(): boolean {
        return this.collectAddress;
    }

    // TODO deprecate
    getCurrency(): Currency {
        return this.currency;
    }

    hasAmountChoice(): boolean {
        return this.allowCustomAmount || this.predefinedAmounts.length > 1;
    }

    hasFrequencyChoice(): boolean {
        return this.getFrequencyOptions().length > 1;
    }

    getFrequencyOptions(): CycleUnit[] {
        return this.frequencyOptions.map(option => CycleUnit.fromValue(option));
    }

    getName(): string {
        return "";
    }

    computeFeeFromAmount(amount: number): number {
        if (!amount) {
            return 0;
        }
        return Math.ceil((getFeeRawPercentage(this.merchantId) * amount / 1e6 + 0.3) * 2) * 5e5;
    }

    static getAvailable(): DonationOffer[] {
        return this.all();
    }
}


export async function apiMerchantEditDonationOffer(data: any): Promise<any> {
    return apiClient.post("/merchant/edit_donation_offer", data);
}
